export default function HamburguerButton(){
    return(
        <button className="navbar-toggler" data-target="#myNavbar" data-toggle="collapse" type="button">
            <span className="navbar-toggler-icon"></span>
        </button>
    );
}